import React from 'react';
import { FilterKAI } from '../../../../components/Icons';
import AIAnalysisModule from './AIAnalysisModule';
import { RightPanelModule } from '../../../components/NewTable/RightPanel/RightPanelContext';

/**
 * AI Analysis Module Configuration
 *
 * Defines the static properties of the AI Analysis module for the right panel
 */
const aiAnalysisModuleConfig = {
  id: 'ai-analysis',
  name: 'AI Analysis',
  icon: <FilterKAI />,
  component: AIAnalysisModule,
  enabled: true,
  expandEnabled: false,
  notListOnModuleBrowser: true, // Hack to hide AI Analysis from the module browser
  keyboardShortcut: 'k',
  order: 3,
};

export default aiAnalysisModuleConfig;
